import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { detailsSchema } from '../../schemas/installationDetailsSchema';
import { ParcelNumber } from '../BurnPermit/ParcelNumber';
import { ControlButtons } from '../ControlButtons';
export const LPGInstallation = ({
	currInstallationDetails,
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	enableLoading = false,
}) => {
	const [tankType, setTankType] = useState(currInstallationDetails.type);

	const { register, unregister, handleSubmit, formState } = useForm({
		resolver: yupResolver(detailsSchema),
		defaultValues: { ...currInstallationDetails, type: 'Above Ground' },
	});

	useEffect(() => {
		unregister('type');
	}, [tankType, unregister]);

	return (
		<Container className="component">
			<Container className="p-0 mt-5 component">
				<h2 className="mb-4">Installation Details</h2>
				<Row>
					<Form.Label className="pl-3" style={{ position: 'absolute' }}>
						Tank Type
					</Form.Label>
					<Form.Group as={Col} xs={11} md={6} className="mt-3" id="TankType">
						<div
							className={
								tankType === 'Above Ground'
									? 'TankTypeButton btn-primary'
									: 'TankTypeButton'
							}
							onClick={() => {
								setTankType('Above Ground');
							}}>
							<Form.Check
								name="type"
								inline
								type="radio"
								label="Above Ground Tank"
								value={tankType}
								checked={tankType === 'Above Ground'}
								{...(tankType === 'Above Ground' ? register('type') : null)}
							/>
						</div>
						<div
							className={
								tankType === 'Below Ground'
									? 'TankTypeButton btn-primary'
									: 'TankTypeButton'
							}
							onClick={() => {
								setTankType('Below Ground');
							}}>
							<Form.Check
								name="type"
								inline
								type="radio"
								label="Below Ground Installation"
								value={tankType}
								checked={tankType === 'Below Ground'}
								{...(tankType === 'Below Ground' ? register('type') : null)}
							/>
						</div>
						<Form.Text className="text-danger">
							{formState.errors.type?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} xs={12} md={6} className="mb-3">
						<Form.Label>Tank Size</Form.Label>
						<Form.Control type="text" {...register('size')} />
						<Form.Text className="text-danger">
							{formState.errors.size?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<hr />

				<Row>
					<Form.Group as={Col} xs={12} md={12} className="mb-3">
						<Form.Label>State Licenced LPG Contractor</Form.Label>
						<Form.Control
							type="text"
							id="contractorField"
							{...register('contractor')}
						/>
						<Form.Text className="text-danger">
							{formState.errors.contractor?.message}
						</Form.Text>
					</Form.Group>
				</Row>

				<hr />
				<Row>
					<Form.Group as={Col} xs={12} md={12} className="mb-3">
						<Form.Label>
							Utah County Building Permit Number{' '}
							<span className="text-secondary">
								(For new construction only)
							</span>
						</Form.Label>
						<Form.Control type="text" {...register('permit')} />
						<Form.Text className="text-danger">
							{formState.errors.permit?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<Row>
					<Form.Group as={Col} xs={12} md={12} className="mb-3">
						<Form.Label>Parcel Number </Form.Label>
						<ParcelNumber
							unregister={unregister}
							register={register}
							error={formState.errors}></ParcelNumber>
						<Form.Text className="text-danger">
							{formState?.errors?.parcelNumber?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<hr />
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				finalStep={finalStep}
				disablePrev={disablePrev}
				disableNext={disableNext}
				enableLoading={enableLoading}
			/>
		</Container>
	);
};
